import Pusher from "pusher-js";

export const pusher = new Pusher('99fde512f2ca4a10be1d', {
    cluster: 'us2'
  });